/*
 * Module for tracking standardized analytics.
 */

var { getParameterByName, urlToLocation } = require("./helpers");
var DataConsent = require('./dataConsent');

var ANALYTICS = (function () {
    var gtagID = "G-LLLW9F9XPC"
    var googleAnalyticsAlreadyInitialized = false;

    /*
     * Google Analytics
     */
    var DIMENSION_PARENT_URL = 'dimension1';
    var DIMENSION_PARENT_HOSTNAME = 'dimension2';
    var DIMENSION_PARENT_INITIAL_WIDTH = 'dimension3';

    var setupGoogle = function() {
        // Bail early if opted out of Performance and Analytics consent groups
        if (!DataConsent.hasConsentedTo(DataConsent.PERFORMANCE_AND_ANALYTICS)) return;

        var script = document.createElement("script")

        script.src = "https://www.googletagmanager.com/gtag/js?id=" + gtagID
      
        script.async = true;
      
        var script_embed = document.createElement("script")
      
        script_embed.innerHTML = "window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '" + gtagID + "');"
      
        document.head.append(script, script_embed)

        // By default Google tracks the query string, but we want to ignore it.
        var location = window.location.protocol +
            '//' + window.location.hostname +
            window.location.pathname;

        gtag('set', 'location', location);
        gtag('set', 'page', window.location.pathname);

        // Custom dimensions & metrics
        var parentUrl = getParameterByName('parentUrl') || '';
        var parentHostname = '';

        if (parentUrl) {
            parentHostname = urlToLocation(parentUrl).hostname;
        }

        var initialWidth = getParameterByName('initialWidth') || '';

        var customData = {};
        customData[DIMENSION_PARENT_URL] = parentUrl;
        customData[DIMENSION_PARENT_HOSTNAME] = parentHostname;
        customData[DIMENSION_PARENT_INITIAL_WIDTH] = initialWidth;

        // Track pageview
        gtag('config', gtagID, {'custom_map': {'dimension1': 'parentUrl', 'dimension2': 'parentHostname', 'dimension3': 'initialWidth'}});
		gtag('event', 'page_view', customData);
        googleAnalyticsAlreadyInitialized = true;
     }

    /*
     * Event tracking.
     */
    var trackEvent = function(eventName, label, value) {
        // Bail early if opted out of Performance and Analytics consent groups
        if (!DataConsent.hasConsentedTo(DataConsent.PERFORMANCE_AND_ANALYTICS)) return;

        var eventData = {
            'hitType': 'event',
            'eventCategory': document.title,
            'eventAction': eventName
        }

        if (label) {
            eventData['eventLabel'] = label;
        }

        if (value) {
            eventData['eventValue'] = value
        }

        // Track details about the parent with each event
        var parentUrl = getParameterByName('parentUrl') || '';
        var parentHostname = '';
        if (parentUrl) {
            parentHostname = urlToLocation(parentUrl).hostname;
        }
        eventData[DIMENSION_PARENT_URL] = parentUrl;
        eventData[DIMENSION_PARENT_HOSTNAME] = parentHostname;

        gtag("event", eventData['eventCategory'], {'type': eventName, 'label': label, 'value': value} );
    }

    setupGoogle();

    // Listen for DataConsentChanged event
    document.addEventListener('npr:DataConsentChanged', () => {
        // Bail early if GA's already been set up
        if (googleAnalyticsAlreadyInitialized) return;

        // When a user opts into performance and analytics cookies, initialize GA
        if (DataConsent.hasConsentedTo(DataConsent.PERFORMANCE_AND_ANALYTICS)) {
            setupGoogle();
        }
    });

    return {
        'trackEvent': trackEvent
    };
}());

module.exports = ANALYTICS;